/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {AbmsBoard} from './abms-board.model';
import {Service} from '../../../common/service.class';
import {UserModelListService} from '../../../common/user-model-list.service';

@Injectable()
export class AbmsBoardService extends UserModelListService<AbmsBoard> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'abmsBoard', AbmsBoard);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/board/abms/abms-board.service.ts